import { Auth } from '@/containers/useAuth';

export const useWorkshopId = () => {
  const { user } = Auth.useContainer();

  return user?.workshopId;
};
